<template>
  <div class="voucher-list">
    <h6 class="voucher-list__title">
      My Vouchers
    </h6>
    <div class="voucher-list__wrapper">
      <VouchersListItem
        v-for="voucher in vouchers"
        :key="voucher.id"
        :voucher="voucher"
      />
      <a
        :href="`//${checkoutUrl}?products=ine-ind-cert-icca-cloud-associate`"
        class="voucher-list__get"
      >
        <div class="voucher-list__icon-wrapper">
          <PlusSymbolIcon class="voucher-list__plus-icon" />
        </div>
        <p class="voucher-list__get-vouchers">GET Vouchers</p>
      </a>
    </div>
  </div>
</template>

<script>
import VouchersListItem from '@/components/user-dashboard/certifications/VouchersListItem.vue'
import PlusSymbolIcon from '@/assets/icons/plus_symbol_icon.svg'

export default {
  name: 'VouchersList',
  components: {
    VouchersListItem,
    PlusSymbolIcon: { ...PlusSymbolIcon, name: 'PlusSymbolIcon' },
  },
  props: {
    vouchers: {
      type: Array,
      required: true,
    },
  },
  computed: {
    checkoutUrl() {
      return process.env.VUE_APP_CHECKOUT_URL
    },
  },
}
</script>

<style lang="scss">
.voucher-list {
  &__title {
    font-size: rem(24);
    line-height: 32px;
    color: var(--white);
    padding: 0;
    margin: 30px 0;
    width: 100%;
  }
  &__get {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    flex-grow: 1;
    color: var(--white);
    padding: 3%;
    width: 100%;
    border: 1px dashed var(--perfect-gray);
    &:hover {
      opacity: 0.8;
    }
  }
  &__get-vouchers {
    text-transform: uppercase;
    font-size: rem(12);
    font-weight: bold;
    line-height: 14px;
    color: var(--perfect-gray);
    margin: 10px 0px;
  }
}
</style>
